import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.pl.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import { mount } from '../dom-lifecycle';
import { mountRuleValidator } from './validation';
import { validatePolish } from 'validate-polish';
import IBAN from 'iban';
import './files';
import './prize-variant';

$.fn.datepicker.defaults.language = "pl";
$.fn.datepicker.defaults.format = "dd.mm.yyyy";
$.fn.datepicker.defaults.defaultViewDate = new Date();
$.fn.datepicker.defaults.maxViewMode = 'month';
$.fn.datepicker.dates.pl.monthsTitle = 'Miesiące';
$.fn.datepicker.dates.pl.daysMin = ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'sb'];
$.fn.datepicker.defaults.templates = {
    leftArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" fill="none"><path stroke="#118787" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M9 1.5 1.5 9 9 16.5"/></svg>',
    rightArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" fill="none"><path stroke="#118787" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M1.5 16.5 9 9 1.5 1.5"/></svg>',
};
$.fn.datepicker.defaults.autoclose = true;

mount('input[data-type=datepicker]', el => {
    let { picker } = $(el).datepicker().data('datepicker');
    picker.find('thead .datepicker-switch').each(function () {
        $(this).parent().append($(this).siblings('.prev, .next'));
    });
});

mountRuleValidator('input[data-type=pesel]', 'pesel', input => validatePolish.pesel(input.value));
mountRuleValidator('input[data-type=nip]', 'nip', input => validatePolish.nip(input.value));
mountRuleValidator('input[data-type=iban]', 'iban', input => IBAN.isValid(input.value));
